/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface TeacherProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Teacher: React.FC<TeacherProps> = ({ color = 'black', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.37404 2.82218L3.35737 6.09718C1.74904 7.14718 1.74904 9.49718 3.35737 10.5472L8.37404 13.8222C9.27404 14.4139 10.7574 14.4139 11.6574 13.8222L16.649 10.5472C18.249 9.49718 18.249 7.15552 16.649 6.10552L11.6574 2.83052C10.7574 2.23052 9.27404 2.23052 8.37404 2.82218Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.69046 11.614L4.68213 14.5223C4.68213 15.5806 5.4988 16.714 6.4988 17.0473L9.15713 17.9306C9.61546 18.0806 10.3738 18.0806 10.8405 17.9306L13.4988 17.0473C14.4988 16.714 15.3155 15.5806 15.3155 14.5223V11.6556"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8337 13.2141V8.21407"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
